/**
 * Rank-label style preference (card-preferences design § B): `german` (U/O, Altenburger
 * convention) vs `french` (B/D, Bube/Dame) for the Jack/Queen corner glyph — a choice that only
 * exists in the German UI (English already renders J/Q either way; `rankJackFrench`/
 * `rankQueenFrench` resolve identically to `rankJack`/`rankQueen` in the EN bundle). Consumed by
 * `cards/cards.js#rankDisplay` for the card faces and by `term-enhance.js#applyRankStyle` for the
 * learning surfaces' inline rank letters, language-blind by construction. No URL override (YAGNI) — mirrors
 * `sort-order.js`'s shape.
 */
export function rankStyle() {
  return localStorage.getItem("rankStyle") === "french" ? "french" : "german";
}

export function setRankStyle(value) {
  localStorage.setItem("rankStyle", value);
}
